import GoogleAnalyticsCustomDimensions from "constants/googleAnalyticsCustomDimension";
import GoogleAnalyticsEvent from "dataTransferObjects/googleAnalyticsEvent";

/* Creates a new instance for housing product type. */
export default class CommunityCard {
    constructor(url, listing) {
      this.url = url;
      this.priceReductionLabel = listing.priceReductionLabel;
      this.communityName = listing.communityName;
      this.brandName = listing.brandName;
      this.marketId = listing.marketId;
      this.city = listing.city;
      this.marketName = listing.marketName;
      this.stateAbbreviation = listing.stateAbbreviation;
      this.id = listing.id;
      this.isBasic = listing.isBasic === "true";
    }
  
    /**
     * This function returns a new GoogleAnalyticsEvent object with the event category, event action,
     * event label and custom dimensions set.
     * @returns A new instance of the GoogleAnalyticsEvent class for card click.
     */
    getCardGoogleAnalyticsEvent() {
      const customDimensions = { 
        [GoogleAnalyticsCustomDimensions.PriceReduction().getName()] :
        this.priceReductionLabel,
        [GoogleAnalyticsCustomDimensions.CommunityName().getName()] :
        this.communityName,
        [GoogleAnalyticsCustomDimensions.BrandName().getName()] :
        this.brandName,
        [GoogleAnalyticsCustomDimensions.MarketId().getName()] : 
        this.marketId,
        [GoogleAnalyticsCustomDimensions.City().getName()] : 
        this.city,
        [GoogleAnalyticsCustomDimensions.MarketName().getName()] : 
        `${this.marketName}, ${this.stateAbbreviation}`,
        [GoogleAnalyticsCustomDimensions.CommunityId().getName()] :
        this.id,
        [GoogleAnalyticsCustomDimensions.IsPaid().getName()] : 
        !this.isBasic,
      };

      const googleAnalyticsDTO = new GoogleAnalyticsEvent('Card-Clicks', 'SRP-Card-Clicks', this.url, customDimensions);

      return googleAnalyticsDTO;
    }
  }
  